import { AuthPage as CoreAuthPage, AuthProps } from '@pankod/refine-chakra-ui';
import ForgotPasswordPage from './forgot-password';

const AuthPage = (props: AuthProps) => {
    const { type } = props;
    const wrapperProps = {
        background: 'radial-gradient(50% 50% at 50% 50%, var(--chakra-colors-gray-200) 0%, var(--chakra-colors-gray-300) 100%)',
        ...props.wrapperProps,
    };

    if (type === 'forgotPassword') {
        return <ForgotPasswordPage {...props} wrapperProps={wrapperProps} />;
    }

    return <CoreAuthPage
        {...{
            ...props,
            wrapperProps,
        }}
    />;
};

export default AuthPage;
